import type { ReactNode } from 'react';
import { BannerCarousel } from '@features/dashboard/BannerCarousel';
import { useResidentModuleBannerLocations, type ResidentBannerModuleKey } from '@shared/hooks/useBannerLocation';

interface RouteBannerFrameProps {
  moduleKey: ResidentBannerModuleKey;
  children: ReactNode;
}

function RouteBanner({ config }: { config: ReturnType<typeof useResidentModuleBannerLocations>['topBanner'] }): JSX.Element | null {
  if (!config) return null;

  return (
    <section className="bg-paper px-5 pt-4">
      <BannerCarousel
        config={config}
        className="aspect-[16/7] rounded-xl shadow-[0_12px_24px_-20px_rgba(17,24,39,0.45)]"
      />
    </section>
  );
}

export function RouteBannerFrame({ moduleKey, children }: RouteBannerFrameProps): JSX.Element {
  const { topBanner, bottomBanner } = useResidentModuleBannerLocations(moduleKey);

  if (!topBanner && !bottomBanner) {
    return <>{children}</>;
  }

  return (
    <>
      <RouteBanner config={topBanner} />
      {children}
      <RouteBanner config={bottomBanner} />
    </>
  );
}

export type { ResidentBannerModuleKey };
